import {FormDialogComponent} from "../shared/dialog/form-dialog/form-dialog.component";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {Component, Inject} from "@angular/core";
import {DialogComponentData} from "../shared/dialog/interfaces";
import {DialogService} from "../shared/dialog/dialog.service";
import {FormGroupManager} from "../shared/cml-forms/form-factory.service";
import {DialogComunicationService} from "../shared/dialog/dialog-comunication.service";
import {ValidationService} from "../shared/cml-forms/validation.service";


@Component({
    selector: 'cml-definice-vykazu-form-service',
    templateUrl: '../shared/dialog/form-dialog/form-dialog.component.html',
    styleUrls: ['../shared/dialog/form-dialog/form-dialog.component.scss'],
    standalone: false
})
export class DefiniceVykazuFormDialogService extends FormDialogComponent
{
  constructor(dialogService: DialogService,
              dialogRef: MatDialogRef<DefiniceVykazuFormDialogService>,
              formManager: FormGroupManager,
              dialogComunicationService: DialogComunicationService,
              validationService: ValidationService,
              @Inject(MAT_DIALOG_DATA) public override data: DialogComponentData)
  {
    super(dialogRef,data , dialogService, formManager, dialogComunicationService, validationService);
  }

  override async ngOnInit(): Promise<void> {
  await super.ngOnInit();
    this.form.controls["upload"].valueChanges.subscribe(() => {
      this.loadProvidedFile();
    });
  }

  private loadProvidedFile() {
    const inpControl = this.form.controls["upload"];
    if (!inpControl) {
      throw new Error("Form control UPLOAD doesn't exist");
    }
    if (!inpControl.value) {
      this.data.component.excelFile = undefined;
      return;
    }
    let file = new FileReader();
    file.onload = async () => {
      this.data.component.excelFile = file.result;
    }
    file.readAsArrayBuffer(inpControl.value);
  }

}
